// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"418":"54d56605","637":"f3775fea","668":"5b1d7f94"}[chunkId] + ".js";
};